import { graphql, useStaticQuery } from "gatsby"

export const useSliderAttivita = () => {
  const {
    allWp: { edges},
  } = useStaticQuery(graphql`
    query sliderAttivita {
        allWp {
            edges {
              node {
                id
                attivitaSettings {
                  attivita_contenuti {
                    testiAttivita{
                      galleria {
                        localFile {
                          children {
                            ... on ImageSharp {
                              id
                              resize(height: 168, width: 300, cropFocus: CENTER) {
                                src
                              }
                            }
                          }
                          childrenImageSharp {
                            original {
                              src
                              width
                              height
                            }
                            resize(height: 168, width: 300) {
                              src
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
    }
  `)

  return edges[0].node.attivitaSettings.attivita_contenuti.testiAttivita
}